import React from 'react';
import { Helmet } from 'react-helmet-async';
import PromoBanner from '../components/Sections/PromoBanner';
import Hero from '../components/Sections/Hero';
import Features from '../components/Sections/Features';
import Benefits from '../components/Sections/Benefits';
import CustomerLogos from '../components/Sections/CustomerLogos';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>FlowSky CRM - Kapsamlı Müşteri İlişkileri Yönetimi</title>
        <meta 
          name="description" 
          content="FlowSky CRM ile gününüzü iş planlarıyla kolayca planlayın, ekibinize görevler atayın ve çalışanlarınızın yoğunluk durumunu takip ederek yönetilebilirliği artırın. Ücretsiz deneme ile başlayın."
        />
        <meta property="og:title" content="FlowSky CRM - Kapsamlı CRM Çözümü" />
        <meta property="og:description" content="İşinizi büyütmek için kapsamlı CRM çözümü" />
        <meta property="og:type" content="website" />
      </Helmet>
      
      <PromoBanner />
      <Hero />
      <Features />
      <Benefits />
      <CustomerLogos />
    </>
  );
};

export default Home;

